// extracted by mini-css-extract-plugin
export default {"cardHeader":"PaymentMethodForm_cardHeader__2UryN","cardHeaderField":"PaymentMethodForm_cardHeaderField__0uhKw","cardIcons":"PaymentMethodForm_cardIcons__mrYSJ"};